import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteSkill } from "../../api/apiSkills";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف مهارة (soft delete)
 */
export function useDeleteSkill() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteSkillMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteSkill,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["skills"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete skill");
        },
    });

    return {
        deleteSkillMutate,
        isPending,
    };
}